console.log('Hello April')
//variant picker
function variantPicker(){
  var picker = document.querySelectorAll('.base-variant-card');
  var popup = document.querySelector('.base-pop-up');
  var overlay = document.querySelector('.base-overlay');
  var cart = document.querySelector('.base-cart');
  var variantall = document.querySelector('.pot-selector-all');
  var closePop = document.querySelector('.close-overlay');
  var menuWrapper = document.querySelector('.base-slide-menu');
  var menu = document.querySelector('.base-hamburger');
  var logo = document.querySelector('.base-logo');
  var continueButton = document.querySelector('.base-close-pop');
  var close = document.querySelector('.base-pop-up-close');

  if(picker){
    console.log('variant picker init');

    for(i=0; i<picker.length; i++) {
      picker[i].addEventListener('click', function(){
        variantUpdate();
        popup.classList.add('visible');
        overlay.classList.add('visible');
      });
    }
    if(variantall) {
      variantall.addEventListener('click', function(){
        popup.classList.add('visible');
        overlay.classList.add('visible');
      });
    }
    if(overlay) {
      overlay.addEventListener('click', function(){
        popup.classList.remove('visible');
        this.classList.remove('visible');
        cart.classList.remove('visible');
        menuWrapper.classList.remove('hovered');
        menu.classList.remove('hovered');
        logo.classList.remove('hovered');
        document.querySelector('body').classList.remove('fix');
      });
    }
    if(closePop) {
      closePop.addEventListener('click', function(){
        popup.classList.remove('visible');
        overlay.classList.remove('visible');
        cart.classList.remove('visible');
      });
    }
    if(close) {
      close.addEventListener('click', function(){
        popup.classList.remove('visible');
        overlay.classList.remove('visible');
        cart.classList.remove('visible');
      });
    }
    if(continueButton) {
      continueButton.addEventListener('click', function(){
        popup.classList.remove('visible');
        overlay.classList.remove('visible');
        cart.classList.remove('visible');
        document.querySelector('body').classList.remove('fix');
      });
    }
  }
}
function accordian(){
  var accordianSelector = document.querySelectorAll('.base-product-accordian');
  if(accordianSelector) {
    for (var i = 0; i < accordianSelector.length; i++) {
      accordianSelector[i].addEventListener('click', function(){
        this.classList.toggle('clicked');
        // this.querySelector('p').classList.toggle('display');
        this.querySelector('div').classList.toggle('display');
      });
    }
  }
}
function addToCart() {
  var addTo = document.querySelector('.base-button-cart');
  var cart = document.querySelector('.base-cart');
  var overlay = document.querySelector('.base-overlay');
  var basketIcon = document.querySelector('.icon-cart');
  var body = document.querySelector('body');

  if(basketIcon) {
    basketIcon.addEventListener('click', function(){
      cart.classList.add('visible');
      overlay.classList.add('visible');
      body.classList.add('fix');
    });
  }

  if(addTo) {
  addTo.addEventListener('click', function(){
    cart.classList.add('visible');
    overlay.classList.add('visible');
    body.classList.add('fix');
  });
  }
}

var sliderCheck = document.querySelector('.slider');

function carousel() {
  var slider = document.getElementById('slider'),
      sliderItems = document.getElementById('items'),
      prev = document.getElementById('prev'),
      next = document.getElementById('next');

  slide(slider, sliderItems, prev, next);

  function slide(wrapper, items, prev, next) {
    var posX1 = 0,
        posX2 = 0,
        posInitial,
        posFinal,
        threshold = 100,
        slides = items.getElementsByClassName('slide'),
        slidesLength = slides.length,
        slideSize = items.getElementsByClassName('slide')[0].offsetWidth,
        firstSlide = slides[0],
        lastSlide = slides[slidesLength - 1],
        cloneFirst = firstSlide.cloneNode(true),
        cloneLast = lastSlide.cloneNode(true),
        index = 0,
        allowShift = true;

    // Clone first and last slide
    items.appendChild(cloneFirst);
    items.insertBefore(cloneLast, firstSlide);
    wrapper.classList.add('loaded');

    // Mouse and Touch events
    items.onmousedown = dragStart;

    // Touch events
     items.addEventListener('touchstart', dragStart);
     items.addEventListener('touchend', dragEnd);
     items.addEventListener('touchmove', dragAction);

    // Click events
    prev.addEventListener('click', function () { shiftSlide(-1) });
    next.addEventListener('click', function () { shiftSlide(1) });

    // Transition events
    items.addEventListener('transitionend', checkIndex);

    function dragStart (e) {
      e = e || window.event;
      e.preventDefault();
      posInitial = items.offsetLeft;

      if (e.type == 'touchstart') {
        posX1 = e.touches[0].clientX;
      } else {
        posX1 = e.clientX;
        document.onmouseup = dragEnd;
        document.onmousemove = dragAction;
      }
    }

    function dragAction (e) {
      e = e || window.event;

      if (e.type == 'touchmove') {
        posX2 = posX1 - e.touches[0].clientX;
        posX1 = e.touches[0].clientX;
      } else {
        posX2 = posX1 - e.clientX;
        posX1 = e.clientX;
      }
      items.style.left = (items.offsetLeft - posX2) + "px";
    }

    function dragEnd (e) {
      posFinal = items.offsetLeft;
      if (posFinal - posInitial < -threshold) {
        shiftSlide(1, 'drag');
      } else if (posFinal - posInitial > threshold) {
        shiftSlide(-1, 'drag');
      } else {
        items.style.left = (posInitial) + "px";
      }

      document.onmouseup = null;
      document.onmousemove = null;
    }

    function shiftSlide(dir, action) {
      items.classList.add('shifting');

      if (allowShift) {
        if (!action) { posInitial = items.offsetLeft; }

        if (dir == 1) {
          items.style.left = (posInitial - slideSize) + "px";
          index++;
        } else if (dir == -1) {
          items.style.left = (posInitial + slideSize) + "px";
          index--;
        }
      };

      allowShift = false;
    }

    function checkIndex (){
      items.classList.remove('shifting');

      if (index == -1) {
        items.style.left = -(slidesLength * slideSize) + "px";
        index = slidesLength - 1;
      }

      if (index == slidesLength) {
        items.style.left = -(1 * slideSize) + "px";
        index = 0;
      }

      allowShift = true;
    }
  }
}

window.addEventListener('load', function(){

  var gliders = document.querySelectorAll('.glider');
  console.log(gliders);

  for(i=0; i< gliders.length; i++) {
    var arrowPrev = gliders[i].parentNode.querySelector('.glider-prev');
    var arrowNext = gliders[i].parentNode.querySelector('.glider-next');
    console.log(arrowPrev, arrowNext);

    new Glider(gliders[i], {
      slidesToShow: 2,
      slidesToScroll: 2,
      draggable: true,
      dots: '.dots',
      arrows: {
        prev: arrowPrev,
        next: arrowNext
      }
    });
  }
})

function menu(){
  var menu = document.querySelector('.base-hamburger');
  var menuWrapper = document.querySelector('.base-slide-menu');
  var logo = document.querySelector('.base-logo');
  var overlay = document.querySelector('.base-overlay');

  menu.addEventListener('mouseover', function(){
    this.classList.add('hovered');
    logo.classList.add('hovered');
    menuWrapper.classList.add('hovered');
    overlay.classList.add('visible');
  });

  menuWrapper.addEventListener('mouseleave', function(){
    this.classList.remove('hovered');
    logo.classList.remove('hovered');
    menu.classList.remove('hovered');
    overlay.classList.remove('visible');
  });

}

var hasSize = false;
var sizeSelected;
var potSelected = 'Plastic';
var dimension;
var ids;

function variants(){
  var variantPicker = document.querySelector('.base-product-variants');
  var jssize = document.querySelector('.js-final-size');
  var jsId = document.querySelector('.js-final-id');
  var addToCartButton = document.querySelector('.base-button-add-to-cart');
  var potsWrapper = document.querySelector('.pot-selector-wrapper');
  var basepProductPrice = document.querySelector('.base-product-price');
  var singlePageTest = document.querySelector('#shopify-section-product-template-single');
  var singlePagePotsTest = document.querySelector('#shopify-section-product-template-pot');
  var skuChange = document.querySelector('.base-number');

  if(singlePageTest || singlePagePotsTest) {
    var variantPicker = document.querySelector('.base-product-variants');
    var jssize = document.querySelector('.js-final-size');
    var jsId = document.querySelector('.js-final-id');
    var addToCartButton = document.querySelector('.base-button-add-to-cart');
    var potsWrapper = document.querySelector('.pot-selector-wrapper');
    var basepProductPrice = document.querySelector('.base-product-price');
    console.log('single page');
    var sizeSplit = variantPicker.value.split('(');
    sizeSelected = sizeSplit[0].trim();
    console.log(sizeSelected);
    var priceComma = variantPicker.options[0].dataset.price?.split(',');
    var price = variantPicker.options[0].dataset.price;
    var stock = variantPicker.options[0].dataset.stock;
    dimension = true;

    if(dimension){
      dimension = sizeSplit[1]?.trim().replace(')', '');
    }
    console.log('dimension', dimension);
    singleSelector(variantPicker, stock, jssize, jsId, addToCartButton, potsWrapper, basepProductPrice, dimension);
  }

  if(variantPicker) {
    const radioButtons = document.querySelectorAll('input[type="radio"][name="Tamaño"]');
    var checkedRadio = 0;
    radioButtons.forEach(function(radioButton, index) {
      if (radioButton.checked) {
        checkedRadio = radioButton;
      }
      radioButton.addEventListener('change', function() {
        if (this.checked) {
          console.log(`Selected option: ${this.value}`);
          // do something else
       
    
   // variantPicker.addEventListener('change', function(evt){
          hasSize = true;
          addToCartButton.classList.remove('deactive');
          var sizeSplit = this.value.split('(');
          sizeSelected = sizeSplit[0].trim();
          var idFinder = sizeSelected;
          jssize.innerHTML = sizeSelected;
          console.log(sizeSelected);
          var dataSelector = '[data-name="'+ idFinder +'"]';
          console.log(dataSelector);
          var id = document.querySelector(dataSelector);
          // jsId.innerHTML = id.dataset.id;
          console.log(id.dataset.id);
          ids = id.dataset.id;
          console.log(ids, 'ids');
          console.log(this.dataset.price);
          var priceComma = this.dataset.price.split(',');
          var price = this.dataset.price;
          var stock = this.dataset.stock;
          var sku = this.dataset.sku;
          var compare = this.dataset.compare;
          if(compare != "") {
            basepProductPrice.innerHTML = priceComma[0] + '<span>,' +  priceComma[1] + ' </span> <div class="base-compare_at_price">' + compare + '</div>';
          }else {
            basepProductPrice.innerHTML = priceComma[0] + '<span>,' +  priceComma[1] + '</span>';
          }
          skuChange.innerHTML = '#' + sku;
          if(stock === "false") {
            addToCartButton.classList.add('deactive');
            addToCartButton.innerText = "AGOTADO";
          }else {
            addToCartButton.classList.remove('deactive');
            addToCartButton.innerText = "AÑADIR A LA CESTA";
          }
          dimension = sizeSplit[1]?.trim().replace(')', '');
          console.log('dimension', dimension);
    
          if(this.value.includes('XS:') || this.value.includes('S:') || this.value.includes('M:') || this.value.includes('L:') || this.value.includes('XL:') || this.value.includes('XXL:')) {
            console.log(stock);
            if(stock != "false") {
              potsWrapper.classList.add('size-selected');
              potsWrapper.classList.remove('hidden');
            }else {
              potsWrapper.classList.remove('size-selected');
            }
            var potSelectorWrapper = document.querySelector('.pot-selector');
            var potCard = potSelectorWrapper.querySelectorAll('.base-variant-card');
            for(i=0; i<potCard.length; i++) {
              potCard[i].classList.remove('available');
              console.log(dimension);
              if(potCard[i].dataset.variantid.includes(dimension)){
                var priceVar = potCard[i].dataset.variantid.split("||");
                var actualPrice;
                for(v = 0; v < priceVar.length; v++) {
                  if(priceVar[v].includes(dimension)) {
                    console.log(priceVar[v]);
                    actualPrice = priceVar[v];
                  }
                }
                splitPriceAcual = actualPrice.split('|');
                var stockCheck = parseInt(splitPriceAcual[3].trim());
                if(stockCheck >= 1) {
                  potCard[i].classList.add('available');
                }
                potCard[i].querySelector('h6').innerText = splitPriceAcual[2];
                var potSelectorImages = document.querySelector('.pot-selector-images .flex');
                var previews = potSelectorImages.querySelectorAll('.base-variant-card');
               }
            }
            //change pots on the fly
            var potSelectorWrapperOut = document.querySelector('.pot-selector-images.outside .flex');
            var potCardOut = potSelectorWrapperOut.querySelectorAll('.base-variant-card');
            for(i=0; i<potCardOut.length; i++) {
              potCardOut[i].classList.remove('available');
              console.log(dimension);
              if(potCardOut[i].dataset.variantid.includes(dimension)){
                var priceVarOut = potCardOut[i].dataset.variantid.split("||");
                var actualPriceOut;
                for(v = 0; v < priceVarOut.length; v++) {
                  if(priceVarOut[v].includes(dimension)) {
                    console.log(priceVarOut[v]);
                    actualPriceOut = priceVarOut[v];
                  }
                }
                splitPriceAcualOut = actualPriceOut.split('|');
                var stockCheckOut = parseInt(splitPriceAcualOut[3].trim());
                if(stockCheckOut >= 1) {
                  potCardOut[i].classList.add('available');
                  console.log(instockPots, 'instock');
                }else {
                  console.log('theser is now stock')
                }
                // potCardOut[i].querySelector('h6').innerText = splitPriceAcual[2];
                var potSelectorImagesOut = document.querySelector('.pot-selector-images.outside .flex');
                var previewsOut = potSelectorImagesOut.querySelectorAll('.base-variant-card');
               }
            }
            var instockPots = document.querySelector('.pot-selector-images.outside .flex .base-variant-card.available');
            if(!instockPots) {
              potsWrapper.classList.add('hidden');
            }
          }
          addToCartButton.dataset.variant = ids;

           }
      });
    });

    if (checkedRadio && radioButtons.length > 1) {
        checkedRadio.dispatchEvent(new Event('change'));
      }
  }
}

function singleSelector(variantPicker, stock, jssize, jsId, addToCartButton, potsWrapper, basepProductPrice, dimension){
  if(variantPicker.value.includes('XS:') || variantPicker.value.includes('S:') || variantPicker.value.includes('M:') || variantPicker.value.includes('L:') || variantPicker.value.includes('XL:') || variantPicker.value.includes('XXL:')) {
    console.log(stock);
    // if(stock != "false") {
    //   potsWrapper.classList.add('size-selected');
    // }else {
    //   potsWrapper.classList.remove('size-selected');
    // }
    var potSelectorWrapper = document.querySelector('.pot-selector');
    var potCard = potSelectorWrapper.querySelectorAll('.base-variant-card');
    for(i=0; i<potCard.length; i++) {
      potCard[i].classList.remove('available');
      console.log(dimension);
      if(potCard[i].dataset.variantid.includes(dimension)){
        var priceVar = potCard[i].dataset.variantid.split("||");
        var actualPrice;
        for(v = 0; v < priceVar.length; v++) {
          if(priceVar[v].includes(dimension)) {
            console.log(priceVar[v]);
            actualPrice = priceVar[v];
          }
        }
        splitPriceAcual = actualPrice.split('|');
        var stockCheck = parseInt(splitPriceAcual[3].trim());
        if(stockCheck >= 1) {
          potCard[i].classList.add('available');
        }
        potCard[i].querySelector('h6').innerText = splitPriceAcual[2];
        var potSelectorImages = document.querySelector('.pot-selector-images .flex');
        var previews = potSelectorImages.querySelectorAll('.base-variant-card');
       }
    }
  }
}

function variantUpdate(){
  var variantPicker = document.querySelector('.base-product-variants');
  var idFinder = sizeSelected;
  console.log(idFinder, 'id');
  var dataSelector = '[data-name="'+ idFinder +'"]';
  var id = document.querySelector(dataSelector);
  ids = id.dataset.id;
}

function potSelector() {
  var potSelectorWrapper = document.querySelector('.pot-selector');
  if(potSelectorWrapper) {
  var potCard = potSelectorWrapper.querySelectorAll('.base-variant-card');
  var jspotname = document.querySelector('.js-pot-name');
  var jssize = document.querySelector('.js-final-size');
  var jsPrice = document.querySelector('.js-product-price');
  var addToCartButton = document.querySelector('.base-button-add-to-cart');
  var selectionCard = document.querySelector('.base-selection-card');
  var potsWrapper = document.querySelector('.pot-selector-wrapper');
  var potImage = document.querySelector('.pot-image');
  var sizeSelector = document.querySelector('.options');

  for(i=0; i<potCard.length; i++) {
    potCard[i].addEventListener('click', function(){
      var thumbs = document.querySelectorAll('.base-image-thumbnails img');
      var findMe = this.querySelector('p').innerText.toLowerCase().trim().replace(/ /g, '');
      var changeImage = document.querySelector('.change-me');
      for(t=0; t<thumbs.length; t++) {
        if(thumbs[t].src.indexOf(findMe) > -1){
          console.log(thumbs[t].src, dimension, findMe);
          if(thumbs[t].src.indexOf(dimension.replace('ø', 'o')) > -1) {
            changeImage.src = thumbs[t].src;
            changeImage.classList.add('changed');
          }
        }
      }

      console.log(thumbs, findMe);

      var preSelected = potSelectorWrapper.querySelector('.base-variant-card.selected');
      if(preSelected){
        preSelected.classList.remove('selected');
      }
      this.classList.add('selected');
      var dataName = this.dataset.name;
      var findSize = dimension;
      var variantsSplit = this.dataset.variantid.split('||');
      console.log(findSize, 'this is the size of plant');
      for(h=0; h < variantsSplit.length; h++) {
        if(variantsSplit[h].includes(findSize)){
          var name = variantsSplit[h];
        }
      }
      var potid = name.split('|');
      ids = ids + ',' + potid[1];
      console.log(ids, 'ids');
      selectionCard.classList.remove('hidden');
      potsWrapper.classList.add('hidden');
      sizeSelector.classList.add('hidden');
      addToCartButton.dataset.variant = ids;
      addToCartButton.innerText = "Comprar Planta + Maceta"
      jspotname.innerHTML = dataName;
      jsPrice.innerHTML = "+ " + potid[2];
      var imageURL = this.querySelector('img').src;
      potImage.innerHTML = '<img src="' + imageURL + '">';
    });
  }
  }
}

function filters() {
  var filterWrapper = document.querySelector('.base-filters');
  var filter = document.querySelectorAll('.filter-selector');
  var selection = document.querySelector('.base-selection-string');
  var selectionString = "";

  if(filterWrapper) {
    filterWrapper.addEventListener('mouseover', function(){
      filterWrapper.classList.add('hovered');
    });
    filterWrapper.addEventListener('mouseleave', function(){
      setTimeout(function(){
        filterWrapper.classList.remove('hovered');
      }, 500)
    });
  }

  for(i=0; i<filter.length; i++) {
    filter[i].addEventListener('click', function(){
      console.log(this.classList, this.dataset.selectable);
      var cards = document.querySelectorAll('.base-product-card');
      for(j=0; j<cards.length; j++) {
        cards[j].classList.add('deselect');
      }
      if(this.dataset.selectable == "true") {
        console.log('do something')
        selectionString = selectionString + '(.' + this.dataset.prop + ')';
        console.log(selectionString);
        this.dataset.selectable = "false";
        var stringToUse = '.base-product-card' + selectionString.replace(/\(/g,"").replace(/\)/g,"").replace('/', '-').toLowerCase();
        console.log(stringToUse, 'touse');

        var selectedCards = document.querySelectorAll(stringToUse);
        console.log(selectedCards);

        for(g=0; g<selectedCards.length;g++) {
          selectedCards[g].classList.remove('deselect');
        }

      } else {
        console.log('do something else', this.dataset.prop);
        this.dataset.selectable = "true";
        var toRemove = '(.' + this.dataset.prop + ')';
        selectionString = selectionString.replace(toRemove, '');
        // console.log(selectionString);
        var stringToUse = '.base-product-card' + selectionString.replace(/\(/g,"").replace(/\)/g,"");
        console.log(stringToUse, 'touse');

        var selectedCards = document.querySelectorAll(stringToUse);
        console.log(selectedCards);

        for(g=0; g<selectedCards.length;g++) {
          selectedCards[g].classList.remove('deselect');
        }
      }
      this.classList.toggle('selected');
    });
  }
}

// function imagePicker(){
//   var imagePicker = document.querySelectorAll('.base-variant-card.available');
//   console.log('init images', imagePicker);
//   var thumbs = document.querySelectorAll('.base-image-thumbnails');
//   for(i=0; i<imagePicker.length; i++){
//     imagePicker[i].addEventListener('click', function(){
//       var findMe = this.querySelector('h5').innerText;
//       for(j=0; j<thumbs.length; j++){
//         console.log(url);
//         var url = thumbs[j].src;
//         if(url.indexOf(findMe) > -1) {
//           // console.log(url);
//         }
//       }
//     });
//   }
// }

function changePot(){
  var potSwitcher = document.querySelector('.base-selection-change');
  var potsWrapper = document.querySelector('.pot-selector-wrapper');
  var selectionCard = document.querySelector('.base-selection-card');
  var optionsHidden = document.querySelector('.options');
  if(potSwitcher) {
    potSwitcher.addEventListener('click', function(){
      selectionCard.classList.add('hidden');
      potsWrapper.classList.remove('hidden');
      optionsHidden.classList.remove('hidden');
    });
  }
}

function orderBy() {
  // Save existing sort parameters
  Shopify.queryParams = {};
  if(location.search.length) {
    for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  // Add existing sort parameters to current URL
  if(document.querySelector('.sort-by')) {
    document.querySelector('.sort-by').addEventListener('change', function(e) {
      var value = e.currentTarget.value;
      Shopify.queryParams.sort_by = value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });
  }
}

function shopthelook(){
  console.log('stl')
  setTimeout(function(){
    console.log('timed', window.location.pathname);
    var path = window.location.pathname.replace('/pages/', '');
    var hotspots = document.querySelectorAll('.lookbook-grid-item');
    var hotspotCheck = document.querySelector('.normal-hotspot');
    if(hotspotCheck) {
      for(i=0; i<hotspots.length; i++) {
        console.log(hotspots);
        hotspots[i].dataset.handle = path;
        // $(hotspots[i]).click(function(){
        //   return false;
        // });
      }
    }
  },3000)
}

function giftaccrodian(){
  var accoridan = document.querySelector('.Regalo-js');
  var gifttext = document.querySelector('.gift-accordian');
  var giftAccordianText = document.querySelector('.gift-accordian-text');
  if(accoridan){
    accoridan.addEventListener('click', function(){
      this.classList.toggle('clicked');
      giftAccordianText.classList.toggle('display');
      gifttext.classList.toggle('display');
    });
  }
}

function menuchildren() {
  var children = document.querySelectorAll('.child');
  for(i=0; i<children.length; i++) {
    children[i].parentNode.parentNode.classList.add('haschild');
    var haschild = document.querySelectorAll('.haschild > li > a');
    for(j=0; j<haschild.length; j++) {
      haschild[j].addEventListener('click', function(e){
        e.preventDefault();
        this.parentNode.parentNode.classList.toggle('display');
      });
    }
  }
}

function filtersButton() {
  console.log('filter button');
  var filters = document.querySelector('.mobile-only');
  if(filters) {
    filters.addEventListener('click', function(){
      this.parentNode.parentNode.parentNode.parentNode.classList.toggle('hovered');
    });
  }
}

function applyButton(){
  var applyButton = document.querySelector('.apply-button');
  var filters = document.querySelector('.base-filters');
  var collectionTitle = document.querySelector('.base-collection-title');
  if(applyButton) {
    applyButton.addEventListener('click', function(){
      filters.classList.remove('hovered');
      window.scrollTo({
        top: 10,
        behavior: 'smooth'
      });
    });
  }
}

function scrollTop(){
  document.addEventListener('scroll', function(){
    var backtotop = document.querySelector('.base-back-to-top');
    var collectionTitle = document.querySelector('.base-collection-title');
    if(collectionTitle){
      if(collectionTitle.getBoundingClientRect().top <= -800) {
        backtotop.classList.add('display');
      }else {
        backtotop.classList.remove('display');
      }
    }
    if(backtotop){
    backtotop.addEventListener('click', function(){
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    }
  });
}

function countdown(){
  if(document.querySelector('.counter-info')){
      function updateTimer() {
      
      var dateSale = document.querySelector('.counter-info').dataset.timer;
      console.log('running timer');
    
      future  = Date.parse(dateSale);
      now     = new Date();
      diff    = future - now;
    
      days  = Math.floor( diff / (1000*60*60*24) );
      hours = Math.floor( diff / (1000*60*60) );
      mins  = Math.floor( diff / (1000*60) );
      secs  = Math.floor( diff / 1000 );
    
      d = days;
      h = hours - days  * 24;
      m = mins  - hours * 60;
      s = secs  - mins  * 60;
    
      document.getElementById("timer")
        .innerHTML =
          '<div><h2>' + d + '</h2><span><p>days</p></span></div>' +
          '<div><h2>' + h + '</h2><span><p>hours</p></span></div>' +
          '<div><h2>' + m + '</h2><span><p>minutes</p></span></div>' +
          '<div><h2>' + s + '</h2><span><p>seconds</p></span></div>' ;
      
    }
    setInterval(function(){
      console.log('interval');
      updateTimer();
    }, 1000);
  }
}

function stickyHeader() {
  var hold = document.querySelector('header').offsetHeight;
    const announcement_bar_height =  document.querySelector('.base-promo-banner')?.offsetHeight; 
  if (announcement_bar_height) {
    document.body.classList.add('have-promo');
  }

    var doc = document.documentElement;
    var w = window;
    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;
    var header = document.querySelector('header');
    var toggled;
    var announcement = document.querySelector(".base-promo-banner");
    var checkScroll = function() {
        curScroll = w.scrollY || doc.scrollTop;
        if (curScroll <= 0) {
            header.classList.remove("scrolled-down-at-middle");
            return;
        }
        if (curScroll > prevScroll) {
            //scrolled down
            direction = 2;
            if(announcement?.classList.contains("announcement-close")){
                header.classList.remove("scroll-down-withoutAnnouncement");
                header.classList.add("scrolled-up");
            }
            else{
                header.classList.remove("scrolled-down-at-middle");
                header.classList.add("scrolled-up");
            }
        } else if (curScroll < prevScroll) {
            //scrolled up
            direction = 1;
            if(announcement?.classList.contains("announcement-close")){
                header.classList.add("scroll-down-withoutAnnouncement");
                header.classList.remove("scrolled-up");
            }
            else{
                header.classList.add("scrolled-down-at-middle");
                header.classList.remove("scrolled-up");
            }
        }
        if (direction !== prevDirection) {
            toggled = toggleHeader()
        }
        if (toggled) {
            prevDirection = direction;
        }
        prevScroll = curScroll;
    };
    var toggleHeader = function() {
        toggled = true;
        if (direction === 2 && curScroll < hold) {
            if(announcement?.classList.contains("announcement-close")){
                header.classList.add("scroll-down-withoutAnnouncement");
                header.classList.remove("scrolled-up");
            }
            else{
                header.classList.add("scrolled-down-at-middle");
                header.classList.remove("scrolled-up");
            }
        } else if (direction === 1) {
            // console.log("remove hide");
        } else {
            toggled = false;
        }
        return;
    };
    window.addEventListener('scroll', checkScroll);

}

function init() {
  variantPicker();
  accordian();
  menu();
  addToCart();
  if(sliderCheck) {
    carousel();
  }
  variants();
  potSelector();
  filters();
  changePot();
  orderBy();
  shopthelook();
  giftaccrodian();
  menuchildren();
  filtersButton();
  applyButton();
  scrollTop();
  countdown();
  stickyHeader();
  // if(document.querySelector('#timer')){
  //   console.log('countdown');
  //
  // }
}init();
